const MODALS_CONTAINER_ID = 'help-widget-modals';

export {MODALS_CONTAINER_ID};
